import React from 'react'
import Header from '../Components/Header'
import ScrollToTop from '../Components/ScrollToTop'
import { motion } from 'framer-motion'
import Depts from '../Components/Depts'
import Footer from '../Components/Footer'
import Donation from '../Components/Donation'


const Ministries = () => {
  return (
    <motion.div
        initial={{ opacity: 0, x: 50 }}
        animate={{ opacity: 1, x: 0 }}
        exit={{ opacity: 0, x: -50 }}
        transition={{ duration: 0.5 }}>
            <div className='App'>
                <ScrollToTop />
                <Header />
                <Depts />
                <Footer />
               <Donation />
            </div>
    </motion.div>
    
  )
}

export default Ministries